type EditPersonalCardArgs = {
  cardId: string;
  cardWorkspaceId?: string;
  returnTo?: string;
};

function buildApiUrl(args: EditPersonalCardArgs): string {
  const params = new URLSearchParams();
  params.set('cardId', args.cardId);
  if (args.cardWorkspaceId) {
    params.set('cardWorkspaceId', args.cardWorkspaceId);
  }
  if (args.returnTo) {
    params.set('returnTo', args.returnTo);
  }
  return `/api/identity/edit-personal-card?${params.toString()}`;
}

/**
 * Calls the edit-personal-card API route and returns the destination URL.
 * The API evaluates the Unified Profile rollout flags server-side and returns
 * either the new identity editor URL or the legacy
 * `/cards/personal/{cardId}/edit` URL. A card is only routed to the new editor
 * when it belongs to the current workspace (team cards shown in the personal
 * list stay on the legacy route).
 *
 * Usage:
 * ```ts
 * const url = await editPersonalCard({ cardId, cardWorkspaceId });
 * router.push(url);
 * ```
 */
export async function editPersonalCard(args: EditPersonalCardArgs): Promise<string> {
  const response = await fetch(buildApiUrl(args));
  const data = await response.json();
  return data.url;
}
